<form #form="ngForm">
    <ng-container *ngIf="reminder">
        <!-- Name/Body -->
        <div class="app-grid">
            <mat-form-field class="columns-6 small-columns-12">
                <mat-label>{{ 'employees.settingsOffboarding.name' | translate }}</mat-label>
                <input matInput type="text" required [(ngModel)]="reminder.name" #name="ngModel" name="name" />
                <mat-error *ngIf="name.invalid">{{ name.errors | formErrors }}</mat-error>
            </mat-form-field>
            <mat-form-field class="columns-6 small-columns-12">
                <mat-label>{{ 'employees.settingsOffboarding.details' | translate }}</mat-label>
                <input matInput type="text" [(ngModel)]="reminder.body" name="body" />
            </mat-form-field>
        </div>

        <!-- Send To -->
        <div class="app-grid">
            <mat-form-field class="columns-6 small-columns-12">
                <mat-label appRemoveAriaOwns>{{ 'employees.settingsOffboarding.sendTo' | translate }}</mat-label>
                <mat-select
                    required
                    [ngModel]="remindToType"
                    (ngModelChange)="setRemindToType($event)"
                    #remindTo="ngModel"
                    placeholder="{{ 'employees.settingsOffboarding.selectAnOption' | translate }}"
                    name="remindTo"
                >
                    <mat-option value="manager">{{ 'employees.settingsOffboarding.manager' | translate }}</mat-option>
                    <mat-option value="employee">{{ 'employees.settingsOffboarding.employee' | translate }}</mat-option>
                    <mat-option value="administrator">{{
                        'employees.settingsOffboarding.administrator' | translate
                    }}</mat-option>
                    <mat-option value="colleague">{{
                        'employees.settingsOffboarding.colleague' | translate
                    }}</mat-option>
                </mat-select>
                <mat-error *ngIf="remindTo.invalid">{{ remindTo.errors | formErrors }}</mat-error>
            </mat-form-field>
            <mat-form-field *ngIf="remindToType === 'colleague'" class="columns-6 small-columns-12">
                <mat-label>{{ 'employees.settingsOffboarding.selectColleague' | translate }}</mat-label>
                <ui-employee-autocomplete
                    [ngModel]="employee"
                    (ngModelChange)="setColleague($event)"
                    required
                    name="colleague"
                    #colleague="ngModel"
                ></ui-employee-autocomplete>
                <mat-error *ngIf="colleague.invalid">{{ colleague.errors | formErrors }}</mat-error>
            </mat-form-field>
        </div>

        <!-- When to Send-->
        <div class="app-grid">
            <mat-form-field class="columns-6 small-columns-12">
                <mat-label appRemoveAriaOwns>{{ 'employees.settingsOffboarding.whenToSend' | translate }}</mat-label>
                <mat-select
                    [(ngModel)]="remindBefore"
                    (ngModelChange)="setRemindBefore(remindBefore)"
                    name="remindBefore"
                    required
                    #remindBeforeInput="ngModel"
                >
                    <mat-option value="on">{{ 'employees.settingsOffboarding.onLastDay' | translate }}</mat-option>
                    <mat-option value="before">{{
                        'employees.settingsOffboarding.beforeLastDay' | translate
                    }}</mat-option>
                    <mat-option value="after">{{
                        'employees.settingsOffboarding.afterLastDay' | translate
                    }}</mat-option>
                </mat-select>
                <mat-error *ngIf="remindBeforeInput.invalid">{{ remindBeforeInput.errors | formErrors }}</mat-error>
            </mat-form-field>

            <mat-form-field *ngIf="remindBefore !== 'on'" class="columns-6 small-columns-12">
                <mat-label>{{
                    remindBefore === 'before'
                        ? ('employees.settingsOffboarding.daysBeforeLastDay' | translate)
                        : ('employees.settingsOffboarding.daysAfterLastDay' | translate)
                }}</mat-label>
                <input
                    matInput
                    type="number"
                    required
                    min="0"
                    [(ngModel)]="reminder.delayDays"
                    #days="ngModel"
                    name="delayDays"
                />
                <mat-error *ngIf="days.invalid">{{ days.errors | formErrors }}</mat-error>
            </mat-form-field>
        </div>
    </ng-container>
</form>
